import { createFileRoute } from "@tanstack/react-router";

import { UsageAllowancesSettingsPanel } from "../components/settings/UsageAllowancesSettings";

export const Route = createFileRoute("/settings/usage")({
  component: UsageAllowancesSettingsPanel,
});
